<template>
  <div class="ai-agent-container" style="position: relative; height: 100%; padding: 10px">
    <!-- Dialog for Create/Edit -->
    <el-dialog
      v-loading="dialogLoading"
      :top="dialogTopMargin"
      :title="(form.id ? '編輯' : '新增') + funcName"
      :visible.sync="dialogVisible"
      width="50%"
    >
      <el-card class="box-card">
        <el-form ref="form" :model="form" :label-width="formLabelWidth">
          <el-form-item
            label="場域名稱"
            prop="siteName"
            :rules="[{ required: true, message: '請輸入場域名稱', trigger: 'blur' }]"
          >
            <el-input v-model="form.siteName"></el-input>
          </el-form-item>

          <el-form-item
            label="場域代碼"
            prop="siteName"
            :rules="[{ required: true, message: '請輸入場域代碼', trigger: 'blur' }]"
          >
            <el-input v-model="form.code"></el-input>
            <i>產生金鑰的代碼</i>
          </el-form-item>

          <el-form-item label="場域金鑰(存檔後產生)" prop="secret">
            <el-input readonly v-model="form.secret"></el-input>
          </el-form-item>

          <el-form-item
            label="Assistants ID"
            prop="assistantsID"
            :rules="[{ required: true, message: '請輸入Assistants ID', trigger: 'blur' }]"
          >
            <el-input v-model="form.assistantsID"></el-input>
          </el-form-item>

          <el-form-item label="狀態">
            <el-switch v-model="form.isEnabled" active-text="啟用" inactive-text="停用">
            </el-switch>
          </el-form-item>
        </el-form>
      </el-card>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveData">確 定</el-button>
      </span>
    </el-dialog>

    <!-- Toolbar -->
    <div style="padding: 20px; padding-bottom: 0">
      <el-form style="display: flex; align-items: flex-end; gap: 0 8px" label-position="left">
        <el-form-item label="場域查詢">
          <el-input v-model="listQuery.search" placeholder="輸入場域名稱" />
        </el-form-item>

        <el-form-item label="狀態">
          <el-select v-model="listQuery.status" clearable placeholder="請選擇狀態">
            <el-option label="啟用" :value="true" />
            <el-option label="停用" :value="false" />
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="getList">查詢</el-button>
        </el-form-item>

        <el-form-item>
          <el-button
            style="cursor: pointer"
            :loading="listLoading"
            type="success"
            icon="el-icon-refresh-left"
            circle
            @click="refresh()"
          ></el-button>
        </el-form-item>

        <el-form-item>
          <el-button type="success" @click="handleCreate">新增{{ funcName }}</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- Table -->
    <div style="position: relative; height: 80%">
      <el-table
        v-loading="listLoading"
        size="mini"
        :data="list"
        border
        fit
        highlight-current-row
        height="100%"
      >
        <el-table-column align="center" label="項次" width="60">
          <template slot-scope="scope">
            <span>{{ scope.$index + 1 }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="場域名稱" min-width="200">
          <template slot-scope="scope">
            <span>{{ scope.row.siteName }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="場域代碼" min-width="100">
          <template slot-scope="scope">
            <span>{{ scope.row.code }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="場域金鑰(存檔後產生)" min-width="300">
          <template slot-scope="scope">
            <el-tag effect="dark" type="danger">{{ scope.row.secret }}</el-tag>
          </template>
        </el-table-column>

        <el-table-column align="center" label="Assistants ID" min-width="300">
          <template slot-scope="scope">
            <el-tag effect="dark" type="info">{{ scope.row.assistantsID }}</el-tag>
          </template>
        </el-table-column>

        <el-table-column align="center" label="狀態" width="100">
          <template slot-scope="scope">
            <el-tag :type="scope.row.isEnabled ? 'success' : 'danger'">
              {{ scope.row.isEnabled ? '啟用' : '停用' }}
            </el-tag>
          </template>
        </el-table-column>

        <el-table-column align="center" label="建立日期" width="160">
          <template slot-scope="scope">
            <span>{{ scope.row.createDate }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="更新日期" width="160">
          <template slot-scope="scope">
            <span>{{ scope.row.updateDate }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="操作" width="150">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="handleEdit(scope.row)">編輯</el-button>
            <el-button size="mini" type="danger" @click="handleDelete(scope.row)">刪除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <pagination
      v-show="total > 0"
      style="padding-top: 0"
      layout="prev, pager, next"
      :total="total"
      :page.sync="listQuery.page"
      :limit.sync="listQuery.limit"
      @pagination="getList"
    />
  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import { MessageBox, Message } from 'element-ui'
import { getAiAgentList, saveAiAgent, deleteAiAgent, updateAiAgentStatus } from '@/api/aiagent'

const defaultForm = {
  id: null,
  siteName: '',
  assistantsID: '',
  isEnabled: true,
}

export default {
  name: 'AiAgentManagement',
  components: {
    Pagination,
  },
  data() {
    return {
      funcName: 'AI Agent',
      dialogTopMargin: '5%',
      formLabelWidth: '120px',
      form: Object.assign({}, defaultForm),
      dialogLoading: false,
      dialogVisible: false,
      listLoading: false,
      listQuery: {
        search: '',
        status: null,
        page: 1,
        limit: 20,
        sort: '-id',
      },
      total: 0,
      list: [],
    }
  },
  created() {
    this.getList()
  },
  methods: {
    async refresh() {
      this.listQuery = {
        search: '',
        status: null,
        page: 1,
        limit: 20,
        sort: '-id',
      }
      await this.getList()
    },

    async getList() {
      this.listLoading = true
      try {
        const response = await getAiAgentList(this.listQuery)
        if (response.success) {
          this.list = response.data
          this.total = response.total
        } else {
          Message.error((error.response && error.response.message) || '獲取資料失敗')
        }
      } catch (error) {
        Message.error((error.response && error.response.message) || '獲取資料失敗')
      }
      this.listLoading = false
    },

    handleCreate() {
      this.form = Object.assign({}, defaultForm)
      this.dialogVisible = true
    },

    handleEdit(row) {
      this.form = Object.assign({}, row)
      this.dialogVisible = true
    },

    handleDelete(row) {
      MessageBox.confirm('確定要刪除此筆資料嗎？', '提示', {
        confirmButtonText: '確定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        try {
          const response = await deleteAiAgent(row.id)
          if (response.success) {
            Message.success(response.message || '刪除成功')
            this.getList()
          } else {
            Message.error(response.message || '刪除失敗')
          }
        } catch (error) {
          Message.error((error.response && error.response.message) || '刪除失敗')
        }
      })
    },

    async saveData() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          try {
            this.dialogLoading = true
            const response = await saveAiAgent(this.form)
            if (response.success) {
              Message.success(response.message)
              this.dialogVisible = false
              this.getList()
            } else {
              Message.error(response.message || '儲存失敗')
            }
          } catch (error) {
            Message.error((error.response && error.response.message) || '儲存失敗')
          } finally {
            this.dialogLoading = false
          }
        }
      })
    },
  },
}
</script>

<style>
.ai-agent-container .el-dialog__body {
  padding-top: 0px;
}
</style>
